import "../App.css";
import post from "../image/Post.png";

export function About() {

    return <div className="Abouts" id="about">
        <div><img id="my_photo" src={post} alt="My face" /></div>
        <div id="details">
            <div>About Me</div>
            <div>An analytical, detail-oriented, and results-driven graduate, passionate about Web development. Skilled in MERN Stack and other development tools. Self-determined and curious about building products. Looking forward to learning, contributing to, and growing with a mid-stage startup.</div>
            <div className="resume" ><a target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1FAU3Mk7vYeSK_wtdEPFdufGXnC3fh02k/view?usp=sharing">Resume</a></div>
        </div>
    </div>
}